import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faImage, faFileAlt } from "@fortawesome/free-solid-svg-icons";
function Attachment(props) {
    const [content, setContent] = useState("");
    const [previewImg, setPreviewImg] = useState("");
    const [previewDoc, setPreviewDoc] = useState(false);
    const [texts, setTexts] = useState({
        title: "Add a new image or file",
        saveLabel: "Click to add files",
    });

    let imageUpload = React.createRef();
    function triggerImageUpload() {
        imageUpload.current.click();
    }

    function showPreviewImg(e) {
        e.preventDefault();
        let reader = new FileReader();
        let file = e.target.files[0];
        if (file) {
            reader.onloadend = function () {
                if (file["type"].split("/")[0] === "image") {
                    setPreviewDoc(false);
                    setPreviewImg(reader.result);
                    setContent(file);
                } else {
                    setContent(file);
                    setPreviewImg(false);
                    setPreviewDoc(true);
                }
            };
            reader.readAsDataURL(file);
        } else {
            setPreviewDoc(false);
            setPreviewImg(false);
        }
    }
    function uploadAndSend() {
        const formData = new FormData();
        formData.append("file", content);
        props.uploadImageCb(formData, content.name, previewImg);
    }
    useEffect(() => {
        if (props.language === "SPANISH") {
            setTexts({
                title: "Agregar una imagen o archivo",
                saveLabel: "Click para subir un archivo",
            });
        }
        // eslint-disable-next-line
    }, []);
    return (
        <div className="attachment-container">
            <div className="modal-heading">
                <h1 className="modal__title"> {texts.title} </h1>
            </div>
            <div className=" attachment attachment-image">
                <input onChange={showPreviewImg} ref={imageUpload} type="file" />
                {previewImg ? (
                    <img onClick={triggerImageUpload} src={previewImg} alt="preview of the file" />
                ) : previewDoc ? (
                    <div className="attachment-preview" onClick={triggerImageUpload}>
                        <div className="text-img">
                            <FontAwesomeIcon icon={faFileAlt} className="add img" />
                            <span className="add-text">{content.name}</span>
                        </div>
                    </div>
                ) : (
                    <div className="attachment-preview" onClick={triggerImageUpload}>
                        <div className="text-img">
                            <FontAwesomeIcon icon={faImage} className="add img" />
                            <span className="add-text">{texts.saveLabel}</span>
                        </div>
                    </div>
                )}
            </div>
            <div className="opt-modal__actions">
                <button className="opt-button opt-button--light" onClick={() => props.closeCb()}>
                    Cancelar
                </button>
                <button className="opt-button" onClick={uploadAndSend} disabled={!content}>
                    Aceptar
                </button>
            </div>
        </div>
    );
}
export default Attachment;
